import React from 'react';
import { css } from '@emotion/react';
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';

const TERMS_URL = 'https://medical.dfree.biz/terms/?webview=1';

const DialogStyles = css`
  .MuiDialog-paper {
    width: calc(100vw - 20px);
    max-width: 920px;
    height: calc(100vh - 20px);
    max-height: 850px;
    margin: 10px;
    border-radius: 12px;
  }
`;

const Title = css`
  padding: 32px 24px 16px;
  color: #444444;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
`;

const Content = css`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 16px;
  padding: 0 34px;
  overflow: hidden;

  @media (max-width: 600px) {
    padding: 0 16px;
  }
`;

const TermsFrame = css`
  width: 100%;
  min-height: 0;
  flex: 1;
  border: 1px solid #cccccc;
  background: #ffffff;
`;

const Agreement = css`
  align-self: center;
  margin: 0;
  color: #444444;

  .MuiFormControlLabel-label {
    font-size: 18px;
    line-height: 1.5;
  }

  @media (max-width: 600px) {
    align-items: flex-start;

    .MuiFormControlLabel-label {
      padding-top: 8px;
      font-size: 14px;
    }
  }
`;

const Actions = css`
  justify-content: center;
  padding: 4px 24px 34px;
`;

const AgreeButton = css`
  min-width: 180px;
  padding: 10px 24px;
  font-size: 18px;
  font-weight: bold;
`;

interface Props {
  isOpen: boolean;
  onAgree: () => void;
}

export const TermsAgreementModal = React.memo(({ isOpen, onAgree }: Props) => {
  const { t } = useTranslation();
  const [isChecked, setIsChecked] = React.useState(false);

  const handleAgree = () => {
    if (isChecked) {
      onAgree();
    }
  };

  return (
    <Dialog
      css={DialogStyles}
      open={isOpen}
      disableEscapeKeyDown
      onClose={() => undefined}
      maxWidth={false}
      scroll='paper'
    >
      <DialogTitle css={Title}>{t('termsOfUse', '利用規約')}</DialogTitle>
      <DialogContent css={Content}>
        <iframe css={TermsFrame} src={TERMS_URL} title={t('termsOfUse', '利用規約')} />
        <FormControlLabel
          css={Agreement}
          control={<Checkbox checked={isChecked} onChange={(_, checked) => setIsChecked(checked)} />}
          label={t(
            'asAStaffMemberOfTheFacilityIAgreeToTheSafetyPrecautionsInTheseTermsAndTheAttachedDocuments',
            '施設の業務として、本規約および添付文書等の安全事項に同意します',
          )}
        />
      </DialogContent>
      <DialogActions css={Actions}>
        <Button css={AgreeButton} variant='contained' disabled={!isChecked} onClick={handleAgree}>
          {t('agree', '同意する')}
        </Button>
      </DialogActions>
    </Dialog>
  );
});
